'use strict';

/**
 * This keeps track of all the image sizes and styles we have through imgix.
 *
 * To add another image ratio, edit the types variable below to include the query string that you'd like to add.
 *
 * Use this like ng-src:
 * <img ms-imgix-src="{{imageURL}}" type="smallSquare">
 */
(function () {
  'use strict';

  angular.module('msUtility').directive('msImgixBackground', msImgixSrc);

  msImgixSrc.$inject = ['imgixDimensions'];

  /* @ngInject */
  function msImgixSrc(imgixDimensions) {
    var directive = {
      link: link,
      restrict: 'A',
      scope: false
    };
    return directive;

    function link(scope, element, attrs) {
      attrs.$observe('msImgixBackground', function (src) {
        element.css('background-image', 'url(' + src + (imgixDimensions[attrs.type] || imgixDimensions['default']) + ')');
      });
    }
  }
})();